import { toast } from 'react-toastify';
const Option = ({ option, id, ans }) => {
    //    This is for show correct, wrong message.
    const rightOrWrong = (selectedOption) => {
        if (selectedOption === ans) {
            toast.success('Correct Ans!', { autoClose: 1000 });
        } else {
            toast.error('Wrong Ans!', { autoClose: 1000 });
        }
    }
    return (
        <div className='bg-lime-50  m-3 rounded-md' id={id} >
            <label className=' inline-block p-4 w-full ' htmlFor={option}>
                <input onClick={() => rightOrWrong(option)} className='mx-2' type="radio" name={id} id={option} />
                {option}
            </label>
        </div>
    );
};

export default Option;